import { useEffect, useState } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';

// The app-wide "working" signal: a thin bar across the top of the window whenever any request is in
// flight — a list filtering, a record saving, a Halo call that takes seconds. It appears only after
// a short delay (fast answers do not flash) and announces itself to assistive tech once.

const SHOW_AFTER_MS = 150;

export function ActivityBar() {
  const busy = useIsFetching() + useIsMutating() > 0;
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!busy) {
      setShown(false);
      return;
    }
    const t = window.setTimeout(() => setShown(true), SHOW_AFTER_MS);
    return () => window.clearTimeout(t);
  }, [busy]);
  return (
    <div className={['hf-activity', shown && 'on'].filter(Boolean).join(' ')} role="progressbar" aria-label="Loading" aria-hidden={!shown} aria-busy={shown}>
      <span />
    </div>
  );
}
